import { CellContext } from '@tanstack/react-table';
import { PhoneNumberDto } from '@/types/PhoneNumberDto.ts';
import { formatPhoneNumber } from '@/types/PhoneNumberDto.utils.ts';
import { EmptyValue } from '@/components/ui/EmptyValue.tsx';

export const phoneNumberFieldRender = <T,>(info: CellContext<T, unknown>) => {
  const value = info.getValue() as PhoneNumberDto | null;
  if (!value) return <EmptyValue />;
  return formatPhoneNumber(value);
};
